
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/open-xd-in-uxpin",
      function () {
        return require("private-next-pages/tutorials/open-xd-in-uxpin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/open-xd-in-uxpin"])
      });
    }
  